import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { StoreProvider } from "./lib/store";
import { Header } from "./components/site/Header";
import { Footer } from "./components/site/Footer";
import { MobileTabBar } from "./components/site/MobileTabBar";
import { SmoothScroll } from "./components/site/SmoothScroll";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Wishlist from "./pages/Wishlist";
import Help from "./pages/Help";
import Admin from "./pages/Admin";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";

function Shell({ children }) {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return <>{children}</>;
  return (
    <>
      <Header />
      {children}
      <Footer />
      <MobileTabBar />
    </>
  );
}

function App() {
  return (
    <StoreProvider>
      <BrowserRouter>
        <SmoothScroll />
        <Shell>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/help" element={<Help />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Shell>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </StoreProvider>
  );
}

export default App;
